import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { BookOpen, Calculator, Briefcase } from "lucide-react";

const services = [
  {
    icon: BookOpen,
    title: "English Level 1",
    description: "Study in a friendly environment.",
    accent: "bg-primary/10",
  },
  {
    icon: BookOpen,
    title: "English Level 2",
    description: "Study to unlock doors in a friendly environment.",
    accent: "bg-secondary/10",
  },
  {
    icon: Calculator,
    title: "Maths Level 1",
    description: "Maths made easy as 123.",
    accent: "bg-primary/10",
  },
  {
    icon: Calculator,
    title: "Maths Level 2",
    description: "Let's do this in your own time, with friendly support.",
    accent: "bg-secondary/10",
  },
  {
    icon: Briefcase,
    title: "Employability Workshops",
    description: "CVs, interviews — Work with us for a better future!",
    accent: "bg-primary/10",
  },
];

export function Services() {
  return (
    <section id="services" className="py-16 md:py-24 bg-muted/30" aria-labelledby="services-heading">
      <div className="container">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <h2 id="services-heading" className="text-3xl md:text-4xl font-display font-bold text-secondary mb-4">
            Our Courses
          </h2>
          <p className="text-lg text-muted-foreground">
            Practical Level 1–2 courses tailored to your goals
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <Card
              key={service.title}
              className="group hover:shadow-card transition-all duration-300 border-border animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <CardHeader>
                <div className={`w-12 h-12 rounded-lg ${service.accent} flex items-center justify-center mb-2 group-hover:scale-110 transition-transform`}>
                  <service.icon className="h-6 w-6 text-primary" aria-hidden="true" />
                </div>
                <CardTitle className="text-xl text-secondary">{service.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base">{service.description}</CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}